/**
 * /frontend/src/features/analytics/components/shared/ErrorState.js
 */

import React from 'react';
import './ErrorState.css';

/**
 * Error state block.
 * @param {{message?:string,onRetry?:Function}} props
 * @returns {JSX.Element}
 */
const ErrorState = ({ message, onRetry }) => (
  <div className="analytics-error" role="alert">
    <p>{message || 'Unable to load analytics. Please try again.'}</p>
    {typeof onRetry === 'function' ? (
      <button type="button" onClick={onRetry}>Retry</button>
    ) : null}
  </div>
);

export default ErrorState;

